import { render } from "./Payment_proposal_creation.vue?vue&type=template&id=378d497b&scoped=true"
import script from "./Payment_proposal_creation.vue?vue&type=script&lang=js"
export * from "./Payment_proposal_creation.vue?vue&type=script&lang=js"

import "./Payment_proposal_creation.vue?vue&type=style&index=0&id=378d497b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378d497b"]])

export default __exports__